import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import isObject from "lodash/isObject";
import pickBy from "lodash/pickBy";

import channelFilter from "utils/channels/filter";
import budgetFilter from "utils/deals/budgetFilter";
import sizeFilter from "utils/deals/sizeFilter";

import startDateFilter from "./deals/startDateFilter";
import { objectContainsKeywords } from ".";

const dealsFilter = (deals, params = {}) => {
  const and =
    (...funcs) =>
    (...innerArgs) =>
      funcs.every((func) => func(...innerArgs));
  const filters = {
    assetIDs:
      (ids) =>
      ({ assets }) => {
        const IDs = ids.map((id) => parseInt(id, 10));

        return assets.some((asset) => includes(IDs, asset.id));
      },
    channels:
      (filterChannels) =>
      ({ channels: allChannels }) =>
        !!channelFilter(allChannels, filterChannels).length,
    pointPersonID: (id) => (deal) => deal.pointPerson.id === parseInt(id, 10),
    stage:
      (stageFilter) =>
      ({ stage }) =>
        includes(stageFilter, stage),
    status:
      (statusFilter) =>
      ({ status }) =>
        statusFilter === "all" || statusFilter === status,
    keywords: (keywords) => (deal) => objectContainsKeywords(deal, keywords),
    probability:
      (probabilityFilter) =>
      ({ probability }) =>
        probabilityFilter === probability,
    size:
      (filter) =>
      ({ size }) =>
        sizeFilter(filter, size),
    budget:
      (filter) =>
      ({ budget, budgetPeriod }) =>
        budgetFilter(filter, { budget, budgetPeriod }),
    startDate:
      (filter) =>
      ({ startDate }) =>
        startDateFilter(filter, startDate),
    default: () => () => true,
  };
  const nonEmptyParams = pickBy(params, (p) => (isObject(p) ? !isEmpty(p) : !!p)); // eslint-disable-line
  const usedFilters = Object.keys(nonEmptyParams).map((k) =>
    (filters[k] || filters.default)(params[k])
  ); // eslint-disable-line

  return deals.filter(and(...usedFilters));
};

export default dealsFilter;
